import * as React from 'react';
import ComponentStatusPicker, { Props } from './component_status_picker';
import ComponentStatusPickerADG3 from './component_status_picker_adg3';

export default function(props: Props) {
  return props.use_adg3 ? (
    <ComponentStatusPickerADG3 {...props} />
  ) : (
    <ComponentStatusPicker {...props} />
  );
}
